import React, { memo } from 'react'
import cn, { Argument as ClassName } from 'classnames'
import { useParams } from 'react-router-dom'
import { Card } from 'primereact/card'

import { PageLayoutContainer } from '../../../lib/page-layout-container'
import { PoolDetailsWidget } from '../../components/pool-details-widget'
import { usePoolGetByIdQuery } from '../../../common/redux/api/web-api'
import { notifySuccess } from '../../../common/features/notificationsManager/Notify'
import useText from '../../../common/hooks/useText'
import { AdminCompanyChargersWidget } from '../../components/admin-company-charge-points/admin-company-chargers-widget'

export type PoolPageProps = {
    className?: ClassName
    style?: React.CSSProperties
}

export const PoolPage = memo(function PoolPageProps(props: PoolPageProps): React.ReactElement {
    const text = useText()

    const { poolId: currentPoolId = '-1' } = useParams()

    const { currentData: poolById } = usePoolGetByIdQuery({
        poolId: currentPoolId,
    })

    const saveEdit = () => {
        notifySuccess(text('msgPoolUpdated'))
    }

    return (
        <>
            <PageLayoutContainer className={cn(props.className)} style={props.style}>
                <Card className="mb-3" title={text('lblPoolPage', { name: poolById?.name ?? '' })}>
                    <PoolDetailsWidget save={saveEdit} poolName={poolById?.name} poolValue={poolById} />
                </Card>

                <AdminCompanyChargersWidget poolId={currentPoolId} />
            </PageLayoutContainer>
        </>
    )
})
